import { useState, useCallback, useMemo } from 'react';

import { MassMessageBuilding, MassMessageSpace } from 'models';

import { has, keyBy } from 'lodash';

import { Collapse, Button } from '@material-ui/core';
import { Checkbox } from 'components';
import { BuildingIcon } from 'components/icons';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import SpacesList from '../spaces-list';

import clsx from 'clsx';
import { useStyles as useCommonStyles } from '../style';
import { useStyles } from './style';

interface BuildingGroupProps {
  building: MassMessageBuilding;
  selectedSpaces: MassMessageSpace[];
  disabled: boolean;
  onSelectSpaces?: (spaces: MassMessageSpace[], checked: boolean) => void;
}

const BuildingGroup = ({
  building,
  disabled,
  selectedSpaces,
  onSelectSpaces,
}: BuildingGroupProps) => {
  const commonClasses = useCommonStyles();
  const classes = useStyles();
  const [expandedSpacesList, setExpandedSpacesList] = useState(false);
  const hasSpaces = !!building.Spaces.length;
  const selectedSpacesDict = useMemo(
    () => keyBy(selectedSpaces, 'Id'),
    [selectedSpaces]
  );
  const selectedAll = useMemo(() => {
    return hasSpaces
      ? building.Spaces.every((space) => {
          return has(selectedSpacesDict, space.Id);
        })
      : false;
  }, [hasSpaces, building, selectedSpacesDict]);
  const selectedAny = useMemo(() => {
    return building.Spaces.some((space) => has(selectedSpacesDict, space.Id));
  }, [selectedSpacesDict, building]);
  const indeterminate = selectedAny && !selectedAll;

  const handleExpandSpacesList = useCallback(() => {
    setExpandedSpacesList((prevState) => !prevState);
  }, []);

  const handleSelectAll = useCallback(() => {
    if (onSelectSpaces) {
      onSelectSpaces(building.Spaces, indeterminate ? false : !selectedAll);
    }
  }, [building.Spaces, selectedAll, onSelectSpaces, indeterminate]);

  return (
    <li className={commonClasses.li}>
      <div className={commonClasses.bar}>
        {hasSpaces ? (
          <Button
            className={clsx(classes.button, {
              [classes.buttonActive]: expandedSpacesList,
            })}
            onClick={handleExpandSpacesList}
          >
            <ChevronRightIcon className={classes.chevronIcon} />
          </Button>
        ) : (
          <div className={commonClasses.mock}></div>
        )}
        <BuildingIcon className={commonClasses.mainIcon} />
        <Checkbox
          disabled={disabled}
          checked={selectedAll}
          indeterminate={indeterminate}
          onChange={handleSelectAll}
        />
        <span className={commonClasses.text}>{building.Name}</span>
      </div>
      <Collapse in={expandedSpacesList}>
        <SpacesList
          spaces={building.Spaces}
          disabled={disabled}
          selectedSpaces={selectedSpaces}
          onSelectSpaces={onSelectSpaces}
        />
      </Collapse>
    </li>
  );
};

export default BuildingGroup;
